import API from "@/lib/API";

export const userService = {
  /**
   * Fetches all employees/users.
   */
  getUsers: async (params = {}) => {
    const response = await API.get('/teams', { params });
    return response || { users: [] };
  },

  /**
   * Fetches user stats.
   */
  getStats: async () => {
    const resp = await API.get('/teams', { params: { limit: 1 } });
    return resp.stats || {};
  }
};

export const fetchUsers = userService.getUsers;





